module.exports = __webpack_public_path__ + "img/number1.a35ea0f9.svg";